import type { FaireProductEntity } from "../../entity_types/product";

export const p_rgpnpvvbw2: FaireProductEntity = {
  token: "p_rgpnpvvbw2",
  type: "product",
  name: "1 LB Wholesale  - Masala Chai Powder",
  brandToken: "b_wlog0i1yg7",
  brandName: "SØUL CHAI",
  imageUrl: "https://cdn.faire.com/fastly/c2d1d6db8e226802cfb49961d13095ccbe09a9a9bd3355154f3cd03f1764b3be.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b3143aad71600f5691f0e7d51454de09127303ee7d13d2c697ec0b0fce8e0ba5.jpeg",
    "https://cdn.faire.com/fastly/aa27bda0a024ddf2db3ec6a4dc0cd614b3cc252c51929b0f80aff4c541f75822.jpeg",
    "https://cdn.faire.com/fastly/fb5375ccbec7d6743ff2e0c3de765c694eee9e653e54aaf3bf95bd1f54a472fd.jpeg",
    "https://cdn.faire.com/fastly/33c8617012fc0f26abf48ae36b83504a40d6c7fc8aaad5380d1f1a8e14517710.png",
    "https://cdn.faire.com/fastly/b0d0c64788931a09165f37d7e258ea5b3ed5283384c58117fabfc7aefa1c0ab0.jpeg",
    "https://cdn.faire.com/fastly/1ef02526e77f298f2a7a3e5d5e9bf737f7da57692697ee0879df47a9b8dfdcf6.jpeg",
    "https://cdn.faire.com/fastly/16fc2c547fc165831133ba84fd7e21468865c06239d8342d3aa70025e678361d.jpeg"
  ],
  priceDollars: 70,
  description: "A vibrant, spiceful chai your baristi are excited to make!\n\nOur original Masala Soul Chai blend available for cafe service in a 1 LB wholesale tin (200+ servings).\n\n• For wholesale approved cafes only, not available for resale. Please reach out to [redacted-email] regarding wholesale inquiries.",
  tags: [],
  msrpDollars: 140,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:58:09.782Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
